import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import getFilteredDateFormatOptions from '../utils/getFilteredDateFormatOptions';
var getNewDateFormat = function () {
    var optionState = getRegionalOptions();
    var UserOptions = getUserConfiguration().UserOptions;
    var newDateFormat = optionState.selectedDateFormat || UserOptions.DateFormat;
    if (getFilteredDateFormatOptions().indexOf(newDateFormat) === -1) {
        // The user changed locales to one that didn't support their previous date format, and didn't update the selection
        // Default to the first option compatible with their locale
        newDateFormat = getFilteredDateFormatOptions()[0];
    }
    return newDateFormat;
};
export default getNewDateFormat;
//# sourceMappingURL=getNewDateFormat.js.map